import { Directive, input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[ospTab]',
  standalone: true,
})
export class TabDirective {
  header = input<string | undefined>(undefined);
  showActive = input<boolean>(false);
  constructor(public template: TemplateRef<unknown>) {}
}
